import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be324f5a&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be324f5a')) {
      api.createRecord('be324f5a', component.options)
    } else {
      api.reload('be324f5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be324f5a&lang=pug", function () {
      api.rerender('be324f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/console/consultant/classRecords/optionFilter/index.vue"
export default component.exports